export const avatarImages = [
    "https://media.simpleviralgames.com/images/vip-avatars/ad125759-8656-49ff-a29f-7cec7587715b.png",
    "https://media.simpleviralgames.com/images/vip-avatars/cac927e4-dc77-4428-add3-fc5d1b269d49.png",
    "https://media.simpleviralgames.com/images/vip-avatars/db7faf62-efc1-45ca-a884-9d1c02959b21.png",
    "https://media.simpleviralgames.com/images/vip-avatars/2cdef452-970b-4c31-b0f8-0cdb5b7404b1.png",
    "https://media.simpleviralgames.com/images/vip-avatars/e7778f23-57ef-4d29-8738-111f587c4680.png",
    "https://media.simpleviralgames.com/images/vip-avatars/608ab791-fca1-4eaa-bbca-353340fdfc63.png",
    "https://media.simpleviralgames.com/images/vip-avatars/e5895f4e-8ecd-4b10-8ca1-3dd19fb04435.png",
    "https://media.simpleviralgames.com/images/vip-avatars/d1162cc3-2dca-430b-af51-452f0bf70809.png",
    "https://media.simpleviralgames.com/images/vip-avatars/720f0759-224b-45e1-8767-388054fa3eec.png",
    "https://media.simpleviralgames.com/images/vip-avatars/e89660e8-399f-493a-95f7-c1fbe40eb71a.png",
];


export const names = [
    "solarBongo88",
    "ragingMonk20",
    "solidRaven892",
    "veilBae430",
    "infernoBison96",
    "supremeSpook67",
    "freeBehemoth24",
    "lifelessSpy09",
    "frozenDroids36",
    "lurkingOracle33",
    "dreadShader403",
    "goldLurk471",
    "cosmicSand04",
    "denseWayfarer23",
    "nightRifter14",
    "plumVoid599",
    "greenGriffin601",
    "renitentRobot36",
    "tightSeeker505",
    "lucentLife773"
]

